<template>
  <v-form ref="form"
          @submit.prevent="submit"
          :disabled="form.busy">
    <v-card>
      <v-card-title>
        Add Domain
      </v-card-title>
      <v-card-text>
        <v-text-field v-model="form.name"
                      label="Domain name"
                      :rules="[rules.required]"
                      :error-messages="form.errors.get('name')">
        </v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn type="submit"
               color="primary"
               :disabled="form.busy">
          Add domain
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import formValidation from '../../plugins/formValidation';

export default {
  mixins: [
    formValidation,
  ],
  data() {
    return {
      form: new Form({
        name: '',
      })
    }
  },
  computed: {
    ...mapGetters([
      'team'
    ]),
  },
  created() {
    this.fetchData();
  },
  methods: {
    initForm() {
      this.form.name = '';
      this.resetForm();
    },
    fetchData() {

    },
    submit() {
      if (this.form.busy) {
        return;
      }
      this.form.post(`/api/team-domains`)
        .then(response => {
          this.$emit('updated')
          this.initForm();
        })
    }
  }
}
</script>
